define("preview-grid/controllers/application", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/debug", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/tracking", "ember-concurrency", "nprogress", "tracked-built-ins", "shared/utils/retry"], function (_exports, _asyncArrowRuntime, _controller, _debug, _object, _computed, _service, _utils, _tracking, _emberConcurrency, _nprogress, _trackedBuiltIns, _retry) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/debug",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-concurrency",0,"nprogress",0,"tracked-built-ins",0,"shared/utils/retry"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let ApplicationController = _exports.default = (_dec = (0, _computed.filterBy)('previewPosts', 'hasBeenEdited'), _dec2 = (0, _computed.filterBy)('previewPosts', 'canEdit'), _dec3 = (0, _computed.gt)('editedPosts.length', 0), _dec4 = (0, _computed.max)('previewPostQueueOrders'), _dec5 = (0, _computed.mapBy)('previewPosts', 'queueOrder'), _dec6 = (0, _computed.sort)('editablePosts', 'queueOrderAsc'), _dec7 = (0, _computed.sort)('activePosts', 'scheduledTimeAsc'), _dec8 = (0, _object.computed)('posts.@each.{scheduledInFuture,active,isDeleted,isInstagramStory,isInstagramReel}', 'socialProfile.id'), _dec9 = (0, _object.computed)('sortedExistingPosts.[]', 'numDisplayScheduledPosts'), _dec10 = (0, _object.computed)('postLimit', 'extraDisplayedScheduledPosts'), _dec11 = (0, _object.computed)('loadNumber', 'limitedSortedExistingPosts'), _dec12 = (0, _object.computed)('igPosts.[]', 'loadNumber'), _dec13 = (0, _object.computed)('igPostPreviewPosts.[]', 'existingPreviewPosts.@each.queueOrder', 'newPreviewPosts.@each.queueOrder'), (_class = class ApplicationController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "alerts", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "schedule", _descriptor5, this);
      _initializerDefineProperty(this, "segment", _descriptor6, this);
      _initializerDefineProperty(this, "store", _descriptor7, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor8, this);
      _initializerDefineProperty(this, "mediaLibrary", _descriptor9, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor10, this);
      _initializerDefineProperty(this, "loadNumber", _descriptor11, this);
      _initializerDefineProperty(this, "isSaving", _descriptor12, this);
      _initializerDefineProperty(this, "extraDisplayedScheduledPosts", _descriptor13, this);
      _initializerDefineProperty(this, "hasSharePlanError", _descriptor14, this);
      _initializerDefineProperty(this, "showSharePlanUpgradeModal", _descriptor15, this);
      _initializerDefineProperty(this, "sharePlan", _descriptor16, this);
      _defineProperty(this, "queueOrderAsc", ['queueOrder:asc']);
      _defineProperty(this, "scheduledTimeAsc", ['scheduledTime:asc']);
      _defineProperty(this, "newPreviewPosts", new _trackedBuiltIns.TrackedArray([]));
      _initializerDefineProperty(this, "editedPosts", _descriptor17, this);
      _initializerDefineProperty(this, "editablePosts", _descriptor18, this);
      _initializerDefineProperty(this, "hasEditedPosts", _descriptor19, this);
      _initializerDefineProperty(this, "maxQueueOrder", _descriptor20, this);
      _initializerDefineProperty(this, "previewPostQueueOrders", _descriptor21, this);
      _initializerDefineProperty(this, "sortedEditablePosts", _descriptor22, this);
      _initializerDefineProperty(this, "sortedExistingPosts", _descriptor23, this);
      _defineProperty(this, "makeSharePlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (!this.auth.currentAccount.canSharePlan) {
            this.segment.track('clicked-share-calendar-intent', {
              location: 'preview grid'
            });
            if (this.subscriptions.isMobileSubscription) {
              this.subscriptions.openMobileRedirectModal('shareCalendar');
            } else {
              this.showSharePlanUpgradeModal = true;
            }
          } else {
            const runMakeSharePlan = async () => {
              await this.createSharePlan.perform();
            };
            try {
              yield (0, _retry.default)(runMakeSharePlan);
            } catch (error) {
              this.hasSharePlanError = true;
            }
          }
        }
      }), null, "makeSharePlan", null));
      _defineProperty(this, "createSharePlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const sharePlan = this.store.createRecord('share-plan', {
            socialProfileId: this.socialProfile.id
          });
          this.sharePlan = sharePlan;
          try {
            yield sharePlan.save();
            this.segment.track('shared-instagram-plan', {
              social_profile_handle: this.socialProfile.nickname ?? '',
              share_url: sharePlan.planUrl ?? ''
            });
          } catch (error) {
            this.errors.log('Make Share Plan failed to create URL', error);
            throw error;
          }
        }
      }), null, "createSharePlan", null));
    }
    get isDragging() {
      return this.schedule.isDragging;
    }
    get sideLibraryBehavior() {
      return this.schedule.sideLibraryBehavior;
    }
    get errorMessage() {
      return this.hasSharePlanError ? this.intl.t('alerts.preview_grid.share_calendar.something_went_wrong') : null;
    }
    get enableAutoSchedule() {
      if (this.isViewingMultiple || (0, _utils.isNone)(this.sideLibraryBehavior)) {
        return false;
      }
      return Boolean(this.hasTimeSlots && this.socialProfile?.hasPublishingMethod);
    }
    get hasTimeSlots() {
      return Boolean(this.socialProfile?.hasUserTimeSlots);
    }
    get socialProfilesSelectedForScheduling() {
      return this.selectedSocialProfiles.profiles.map(profile => profile.accountType);
    }
    get isViewingMultiple() {
      return this.selectedSocialProfiles.hasMultipleSelected;
    }
    get selectedAssets() {
      return this.mediaLibrary.selectedMedia;
    }
    get activePosts() {
      return this.posts.filter(post => post.scheduledInFuture && post.active && !post.isDeleted && this.socialProfile?.id === post.belongsTo('socialProfile').id() && !post.isInstagramStory);
    }
    get limitedSortedExistingPosts() {
      return this.sortedExistingPosts.slice(0, this.numDisplayScheduledPosts);
    }
    get numDisplayScheduledPosts() {
      let numPostsLimit = this.postLimit + this.extraDisplayedScheduledPosts;
      if (numPostsLimit < this.postLimit) {
        numPostsLimit = this.postLimit;
      }
      return numPostsLimit;
    }
    get lastPreviewPostScheduledTime() {
      if (this.previewPosts.length === 0) {
        return null;
      }
      let last = 0;
      this.previewPosts.forEach(item => {
        const {
          scheduledTime
        } = item;
        if (scheduledTime !== undefined && last < scheduledTime && !item.isIgPost) {
          last = scheduledTime;
        }
      });
      if (last === 0) {
        return null;
      }
      return last;
    }

    // don't depend on limitedSortedExistingPosts to guard against double deletes
    // load number triggers reloads as needed
    get existingPreviewPosts() {
      const previewPosts = new _trackedBuiltIns.TrackedArray([]);
      let count = 0;
      this.limitedSortedExistingPosts.forEach(item => {
        const pp = item.igPreviewPost();
        pp.set('originalQueueOrder', count);
        pp.set('queueOrder', count);
        previewPosts.pushObject(pp);
        count = count + 1;
      });
      return previewPosts;
    }
    get igPostPreviewPosts() {
      const previewPosts = new _trackedBuiltIns.TrackedArray([]);
      let count = -1000;
      this.igPosts.forEach(item => {
        const pp = item.igPreviewPost();
        pp.set('originalQueueOrder', count);
        pp.set('queueOrder', count);
        previewPosts.pushObject(pp);
        count--;
      });
      return previewPosts;
    }
    get previewPosts() {
      const previewPosts = new _trackedBuiltIns.TrackedArray([]);
      previewPosts.pushObjects(this.igPostPreviewPosts);
      previewPosts.pushObjects(this.existingPreviewPosts);
      const newToRemove = [];
      this.newPreviewPosts.forEach(item => {
        const alreadyAPost = this.activePosts.find(post => post.belongsTo('mediaItem').id() === (item.mediaItem?.id ?? null) && post.scheduledTime === item.scheduledTime);
        if ((0, _utils.isNone)(alreadyAPost)) {
          previewPosts.pushObject(item);
        } else {
          newToRemove.push(item);
        }
      });
      this.newPreviewPosts.removeObjects(newToRemove);
      return previewPosts;
    }
    get numNewPosts() {
      let numNewPosts = 0;
      this.sortedEditablePosts.forEach(item => {
        if (item.isIgPost) {
          // noop
        } else if (item.isRemoved) {
          numNewPosts--;
        } else if ((0, _utils.isNone)(item.scheduledTime)) {
          numNewPosts++;
        }
      });
      return numNewPosts;
    }
    get numOverPostLimit() {
      if (this.socialProfile.hasUnlimitedPosts) {
        return false;
      }
      if (this.numNewPosts >= this.socialProfile.postsLeft) {
        return this.numNewPosts - this.socialProfile.postsLeft;
      }
      return false;
    }
    get canSave() {
      const overLimit = this.numOverPostLimit;
      return (overLimit === false || overLimit <= 0) && !this.isSaving;
    }
    get shouldShowUpgradeModal() {
      return this.showSharePlanUpgradeModal && !this.auth.currentAccount.canSharePlan;
    }
    showQuickScheduleWizard() {
      this.schedule.isQuickScheduleWizardVisible = true;
    }
    droppedElements(droppedItemIds) {
      const mediaItemIds = droppedItemIds?.split(',').filter(id => id);
      if (!mediaItemIds || (0, _utils.isEmpty)(mediaItemIds)) {
        return;
      }
      this.addNewPreviewPosts({
        mediaItemIds,
        fromQuickSchedule: false
      });
      this.clearSelection();
    }
    revertChanges() {
      this.newPreviewPosts.clear();
      this.previewPosts.forEach(item => {
        item.reset();
      });
      this.loadNumber++;
    }
    saveChanges() {
      if (!this.canSave) {
        return;
      }
      let postsRescheduled = 0;
      let postsRemoved = 0;
      const currentlyScheduled = [];
      const newPosts = [];
      const removedPosts = [];
      _nprogress.default.start();
      this.isSaving = true;
      const toRemove = [];
      this.sortedEditablePosts.forEach(item => {
        if (item.isIgPost) {
          (0, _debug.debug)('++ should not be here ++');
          return;
        }
        if (item.isRemoved) {
          postsRemoved++;
        } else if (item.isCurrentlyScheduled && item.hasUpdatedScheduledTime) {
          postsRescheduled++;
        }
        if (item.isRemoved) {
          removedPosts.push(item.gram?.id ?? '');
          toRemove.push(item);
        } else if ((0, _utils.isNone)(item.scheduledTime)) {
          newPosts.push(item.autoSchedulingId ?? '');
        } else {
          currentlyScheduled.push([item.autoSchedulingId ?? '', item.scheduledTime]);
        }
      });
      const body = {
        scheduled: currentlyScheduled,
        auto_schedule: newPosts,
        remove: removedPosts
      };
      this.socialProfile.previewGrid(body).then(response => {
        toRemove.forEach(item => {
          if (!item.gram?.isDeleted && item.gram?.isDestroyed === false) {
            item.gram.set('active', false);
            item.gram.deleteRecord();
          }
        });
        this.newPreviewPosts.clear();
        this.store.pushPayload(response);
        this.loadNumber++;
        _nprogress.default.done();
        this.isSaving = false;
        this.segment.track('updated-preview', {
          profile: this.socialProfile.nickname ?? '',
          posts_rescheduled: postsRescheduled,
          posts_created: newPosts.length,
          posts_removed: postsRemoved
        });
        let numPostsLimit = this.extraDisplayedScheduledPosts;
        numPostsLimit = numPostsLimit + newPosts.length;
        numPostsLimit = numPostsLimit - postsRemoved;
        this.extraDisplayedScheduledPosts = numPostsLimit;
        this.send('reloadRoute');
      }, error => {
        const {
          errors
        } = error;
        _nprogress.default.done();
        this.isSaving = false;
        errors.forEach(apiError => {
          this.errors.show(apiError.detail);
        });
      });
    }
    removeNewPreviewPost(previewPost) {
      this.newPreviewPosts.removeObject(previewPost);
    }
    addNewPreviewPosts(_ref) {
      let {
        mediaItemIds,
        fromQuickSchedule
      } = _ref;
      if (!this.enableAutoSchedule) {
        return;
      }
      const {
        maxQueueOrder
      } = this;
      let count = maxQueueOrder + 1;
      const newPosts = [];
      const mediaTypeCount = {
        images: 0,
        videos: 0
      };
      mediaItemIds.forEach(mediaItemId => {
        const mediaItem = this.store.peekRecord('media-item', mediaItemId);
        if (!(0, _utils.isNone)(mediaItem)) {
          const previewPost = mediaItem.igPreviewPost(this.socialProfile);
          previewPost.set('originalQueueOrder', count);
          previewPost.set('queueOrder', count);
          newPosts.push(previewPost);
          mediaItem.mediaType === 'image' ? mediaTypeCount.images++ : mediaTypeCount.videos++;
          count = count + 1;
        }
      });
      if (undefined) {
        this.alerts.warning(this.intl.t('alerts.preview_grid.gif.message'), {
          title: this.intl.t('alerts.preview_grid.gif.title')
        });
      } else {
        this.segment.track('started-scheduling-post', {
          area: fromQuickSchedule ? 'dragged_from_side_library_to_quick_schedule_visual_planner' : 'dragged_from_side_library_to_visual_planner',
          type: undefined ?? '',
          is_multi_profile: this.socialProfilesSelectedForScheduling.length > 1,
          multi_profile_types: this.socialProfilesSelectedForScheduling,
          number_of_images: mediaTypeCount.images,
          number_of_videos: mediaTypeCount.videos
        });
        this.newPreviewPosts.pushObjects(newPosts);
      }
      this.schedule.canSchedule(this.socialProfile, {
        numPosts: this.numNewPosts
      });
    }
    clearSelection() {
      this.selectedAssets.clear();
    }
    reset() {
      (0, _object.set)(this, 'igUser', null);
      (0, _object.set)(this, 'igPosts', new _trackedBuiltIns.TrackedArray([]));
      (0, _object.set)(this, 'newPreviewPosts', new _trackedBuiltIns.TrackedArray([]));
      this.loadNumber++;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "schedule", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "mediaLibrary", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "loadNumber", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "isSaving", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "extraDisplayedScheduledPosts", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hasSharePlanError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showSharePlanUpgradeModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "sharePlan", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "editedPosts", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "editablePosts", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "hasEditedPosts", [_dec3], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "maxQueueOrder", [_dec4], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "previewPostQueueOrders", [_dec5], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "sortedEditablePosts", [_dec6], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "sortedExistingPosts", [_dec7], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "activePosts", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "activePosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "limitedSortedExistingPosts", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "limitedSortedExistingPosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numDisplayScheduledPosts", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "numDisplayScheduledPosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "existingPreviewPosts", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "existingPreviewPosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "igPostPreviewPosts", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "igPostPreviewPosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previewPosts", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "previewPosts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showQuickScheduleWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showQuickScheduleWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "droppedElements", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "droppedElements"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revertChanges", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "revertChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveChanges", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeNewPreviewPost", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeNewPreviewPost"), _class.prototype)), _class));
});